import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { DropdownMenuItem } from '@/components/shadcn/dropdown-menu'
import { Button } from '@/components/shadcn/button'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { useState } from 'react'
import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { DataTableV2DataRow, DataTableV2SubmissionAction } from '../types'

export function SubmitActionWithConfirmDialog({
  action,
  formData,
  actionPosition = 'row',
}: {
  action: DataTableV2SubmissionAction
  formData?: DataTableV2DataRow
  actionPosition?: 'table' | 'row'
}) {
  const [isOpen, setIsOpen] = useState(false)
  const { handlerId, id: actionId, confirmationMessage, label, icon } = action
  const { tileFilterSelections } = useTileFilters()
  const { mutate: submitForm, isPending: isSubmitting } = useSubmitForm(
    handlerId,
    [...tileFilterSelections, { actionId }],
    actionId,
    {
      onSuccess: () => setIsOpen(false),
    }
  )

  const onConfirm = () => {
    submitForm(formData as Record<string, unknown>)
  }

  const trigger =
    actionPosition === 'row' ? (
      <div className="flex items-center gap-2">
        <DynamicIcon iconName={icon || ''} lazyLoad={false} className="size-3" fallback={<div className="size-4" />} />
        <span>{label}</span>
      </div>
    ) : (
      <Button variant="ghost" size="icon" className="size-6" disabled={action.isDisabled}>
        <DynamicIcon
          iconName={icon || ''}
          lazyLoad={false}
          fallback={<div className="size-4" />}
        />
        <span className="sr-only">{label}</span>
      </Button>
    )

  const confirmDialog = (
    <ConfirmDialog
      trigger={trigger}
      triggerTooltip={actionPosition === 'table' ? label : undefined}
      isOpen={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
      title={label}
      description={confirmationMessage}
      onConfirm={onConfirm}
      closeOnConfirm={false}
      isSubmitting={isSubmitting}
    />
  )

  if (actionPosition === 'row') {
    return (
      <DropdownMenuItem key={actionId} onSelect={(e) => e.preventDefault()} disabled={action.isDisabled}>
        {confirmDialog}
      </DropdownMenuItem>
    )
  }
  return confirmDialog
}
